import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type SaveExternalAppointmentSignatureOptions = {
  appointmentId: string;
  covid19Signed: string;
  template: string;
  dashboardId?: string;
  retsId?: string;
};

const saveExternalAppointmentSignature = async ({
  appointmentId,
  covid19Signed,
  template,
  dashboardId,
  retsId,
}: SaveExternalAppointmentSignatureOptions) => {
  const config: AxiosRequestConfig = {
    url: `/external/covid19/appointment/${appointmentId}/settings`,
    method: 'post',
    data: {
      appointmentId,
      dashboardId,
      retsId,
      covid19Signed,
      template,
    },
  };

  await axios.request<void>(config);
};

export default saveExternalAppointmentSignature;
